













































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Form, Toast } from 'vant'
import ffButton from '@/components/public/Button.vue'
import ffInput from '@/components/public/Input.vue'
import { addGA, getLang } from '../utils'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
const appStore = namespace('app')
@Component({
  components: {
    ffButton,
    ffInput,
    [Form.name]: Form
  }
})
export default class Register extends Vue {
  private username: string = ''
  private email: string = ''
  private phone: string = ''
  private ddd: string = ''
  private phoneChecked: boolean = false

  @appStore.State((state) => state.transify) private transify: object
  @appStore.State((state) => state.region) private region: any
  @appStore.State((state) => state.nationCode) private nationCode: string
  @appStore.State((state) => state.registerOpen) private registerOpen: boolean
  @appStore.Action('setProfile') private setProfile!: Function
  @appStore.Action('handleError') private handleError!: Function
  validateEmail = (mail: string) => {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true
    }
    return false
  }
  onDDD() {
    const timer = setTimeout(() => {
      let result = ''
      if (this.ddd && this.ddd.length > 0) {
        const tmp = this.ddd.split('')
        tmp.forEach((ele) => {
          if (
            ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(
              ele.toString()
            )
          ) {
            result += ele
          }
        })
        this.ddd = `(${result})`
      }
    }, 300)
  }

  @Watch('ddd', { immediate: true, deep: true })
  watchDDD(val: string, old: string) {
    this.phoneChecked = this.validatePhone(this.phone, this.ddd)
  }

  @Watch('phone', { immediate: true, deep: true })
  watchphone() {
    this.phoneChecked = this.validatePhone(this.phone, this.ddd)
  }

  validatePhone(phone: string, ddd: string): boolean {
    let result = false
    const region = this.region
    switch (region) {
      case 'id':
        if (phone.length > 9 && phone.length < 15 && !isNaN(parseInt(phone))) {
          result = true
        }
        break
      case 'pt':
        if (
          phone.length > 7 &&
          phone.length < 10 &&
          !isNaN(parseInt(phone)) &&
          ddd.length < 5 &&
          ddd.length > 2
        ) {
          result = true
        }
        break

      default:
        if (phone.length > 5 && phone.length < 20 && !isNaN(parseInt(phone))) {
          result = true
        }
        break
    }
    return result
  }
  onSubmit(): void {
    if (this.username === '') {
      return this.handleError('ADV_REGISTRATION_ERROR_TOAST_NAME')
    }
    if (this.email === '') {
      return this.handleError('ADV_REGISTRATION_ERROR_TOAST_EMAIL')
    }
    if (!this.validateEmail(this.email)) {
      return this.handleError('ADV_REGISTRATION_ERROR_TOAST_EMAIL')
    }
    if (this.phone === '') {
      return this.handleError('ADV_REGISTRATION_ERROR_TOAST_PHONE')
    }
    if (!this.phoneChecked) {
      return this.handleError('ADV_REGISTRATION_ERROR_TOAST_PHONE')
    }
    const lang = getLang()
    const profile = {
      lang: this.region,
      name: this.username,
      email: this.email,
      tel: this.formatePhone(this.phone)
    }
    this['$http'].post('/register', profile).then((res: any) => {
      const data = res.data
      Toast['success'](this.transify['ADV_REGISTRATION_SUCCESS'])
      this.setProfile({
        profile: profile,
        apkLink: data.apk_url,
        feedbackQuestions: data.feedback_questions,
        imageUpload: data.feedback_image_upload
      })
      addGA('register', 'success')
      setTimeout(() => {
        this['$router']
          .push({
            path: '/download'
          })
          .catch(() => {
            return
          })
      }, 1000)
    })
  }
  formatePhone(phone: string): string {
    switch (this.region) {
      case 'pt':
        return this.nationCode + this.ddd + phone
      case 'id':
        return this.nationCode + phone
      default:
        return phone
    }
  }
  mounted(): void {
    if (!this.registerOpen) {
      this['$router'].push('/').catch(() => {
        return
      })
    }
  }
}
